module.exports = __webpack_public_path__ + "static/media/use14.64c2fe06.jpeg";